import * as yup from "yup";

export const sourceSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
});
